import request from "root/js/request";

export const postSplitToSuppliesExportByWarehouse = async ({
  cabinet_id,
  warehouse,
  date,
  map,
  dates,
  alter_quantity,
  barcode_id__not_in,
  sales_share_history_period,
}) => {
  const response = await request({
    url: `analytics/wh_supply/split_to_supplies/export/`,
    method: "post",
    params: {
      cabinet_id,
      sales_share_history_period,
      barcode_id__not_in,
      warehouse,
      date,
    },
    data: {
      map,
      dates,
      alter_quantity,
    },
  });
  return response.data;
};

export const postSplitToSuppliesExportTable = async ({
  cabinet_id,
  date,
  map,
  dates,
  alter_quantity,
  barcode_id__not_in,
  sales_share_history_period,
}) => {
  const response = await request({
    url: `analytics/wh_supply/split_to_supplies/${date}/export/`,
    method: "post",
    params: {
      cabinet_id,
      sales_share_history_period,
      barcode_id__not_in,
      date,
    },
    data: {
      map,
      dates,
      alter_quantity,
    },
  });
  return response.data;
};